const REFUND_TYPE_ENUM = {
  TOTAL: 'TOTAL',
  PARTIAL: 'PARTIAL'
}
const isRefundTypeTotal = refundType =>
  refundType.toLowerCase() === REFUND_TYPE_ENUM.TOTAL.toLowerCase()
const isRefundTypePartial = refundType =>
  refundType.toLowerCase() === REFUND_TYPE_ENUM.PARTIAL.toLowerCase()

export { REFUND_TYPE_ENUM, isRefundTypePartial, isRefundTypeTotal }
